import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { NetIncomeSummary } from "types/landlord/reports";
import { ChevronDown, ChevronUp } from "untitledui-js-base";
import { formatToCurrency } from "utils/currency";

const columnHelper = createColumnHelper<NetIncomeSummary>();

export const VerifiedNetEarningsColumns = [
  columnHelper.accessor("month", {
    header: "Date",
    cell: ({ getValue }) => {
      const data = getValue();
      return (
        <p className="text-content-1000 font-medium text-sm">
          {moment(data).format("MMMM, YYYY")}
        </p>
      );
    }
  }),
  columnHelper.accessor("sources", {
    header: "Income source description",
    cell: () => {
      return null;
    }
  }),
  columnHelper.accessor("total_net", {
    id: "right-align",
    header: "Net income",
    cell: ({ getValue }) => {
      return (
        <p className="text-content-1000 font-bold text-sm text-end">
          {formatToCurrency(
            getValue() || {
              cents: 0,
              currency: "USD"
            }
          )}
        </p>
      );
    }
  }),
  {
    id: "expander",
    header: "",
    size: 64,
    cell: ({ row }) => {
      return (
        row.getCanExpand() && (
          <IconButton
            Icon={row.getIsExpanded() ? ChevronUp : ChevronDown}
            onClick={() => row.toggleExpanded()}
            size={IconButtonSize.SM}
            className="!stroke-content-300"
            variant={IconButtonVariant.BASE}
          />
        )
      );
    }
  }
];
